module.exports = __webpack_public_path__ + "img/icon_spark.e7053a4b.svg";